const decodeHtmlEntities = (value) => value
    .replaceAll("&amp;", "&")
    .replaceAll("&lt;", "<")
    .replaceAll("&gt;", ">")
    .replaceAll("&quot;", '"')
    .replaceAll("&#39;", "'");
const normalizeUnicode = (value) => value.normalize("NFKC");
const removeAnnotations = (value) => value
    .replace(/^[0-9]+/g, "")
    .replace(/^(?:No\.?|NO\.?|№)\s*[0-9]+/gi, "")
    .replace(/(?:No\.?|NO\.?|№)\s*[0-9]+/gi, "")
    .replace(/[\u3000\s]*(?:\([^)]*\)|（[^）]*）)/g, "")
    .replace(/[♀♂]/g, "")
    .replace(/[・•·･]/g, "")
    .replaceAll("\u3000", "")
    .replaceAll(" ", "")
    .replaceAll("へ", "ヘ");
const normalizeForMatch = (value) => removeAnnotations(normalizeUnicode(decodeHtmlEntities(value)))
    .toLowerCase()
    .replaceAll("ー", "");
const canonicalMatchers = [
    {
        canonical: "スコティッシュストレート",
        patterns: ["スコティッシュストレート"],
    },
    {
        canonical: "スコティッシュフォールド",
        patterns: ["スコティッシュフォールド", "スコティッシュ"],
    },
    {
        canonical: "アメリカンショートヘア",
        patterns: ["アメリカンショートヘア"],
    },
    {
        canonical: "アメリカンカール",
        patterns: ["アメリカンカール"],
    },
    {
        canonical: "ブリティッシュショートヘア",
        patterns: ["ブリティッシュショートヘア", "ブリティッシュ"],
    },
    {
        canonical: "ブリティッシュロングヘア",
        patterns: ["ブリティッシュロングヘア"],
    },
    {
        canonical: "ノルウェージャンフォレストキャット",
        patterns: [
            "ノルウェージャンフォレストキャット",
            "ノルウェージャンフォレスト",
            "ノルウェージャン",
            "ノルウェイジャン",
        ],
    },
    {
        canonical: "ロシアンブルー",
        patterns: ["ロシアンブルー"],
    },
    {
        canonical: "サイベリアン",
        patterns: ["サイベリアン"],
    },
    {
        canonical: "ラガマフィン",
        patterns: ["ラガマフィン"],
    },
    {
        canonical: "ラグドール",
        patterns: ["ラグドール"],
    },
    {
        canonical: "メインクーン",
        patterns: ["メインクーン"],
    },
    {
        canonical: "マンチカン",
        patterns: ["マンチカン"],
    },
    {
        canonical: "ミヌエット",
        patterns: ["ミヌエット"],
    },
    {
        canonical: "ソマリ",
        patterns: ["ソマリ"],
    },
    {
        canonical: "ペルシャ",
        patterns: ["ペルシャ"],
    },
    {
        canonical: "エキゾチック",
        patterns: ["エキゾチック"],
    },
    {
        canonical: "アビシニアン",
        patterns: ["アビシニアン"],
    },
    {
        canonical: "チンチラ",
        patterns: ["チンチラ"],
    },
    {
        canonical: "ベンガル",
        patterns: ["ベンガル"],
    },
    {
        canonical: "シャム",
        patterns: ["シャム"],
    },
    {
        canonical: "ヒマラヤン",
        patterns: ["ヒマラヤン"],
    },
    {
        canonical: "トンキニーズ",
        patterns: ["トンキニーズ"],
    },
    {
        canonical: "シャルトリュー",
        patterns: ["シャルトリュー"],
    },
    {
        canonical: "ボンベイ",
        patterns: ["ボンベイ"],
    },
    {
        canonical: "シンガプーラ",
        patterns: ["シンガプーラ"],
    },
    {
        canonical: "セルカークレックス",
        patterns: ["セルカークレックス"],
    },
    {
        canonical: "ターキッシュアンゴラ",
        patterns: ["ターキッシュアンゴラ"],
    },
    {
        canonical: "オリエンタルショートヘア",
        patterns: ["オリエンタルショートヘア"],
    },
    {
        canonical: "オリエンタルロングヘア",
        patterns: ["オリエンタルロングヘア"],
    },
    {
        canonical: "日本猫",
        patterns: ["日本猫"],
    },
    {
        canonical: "ラムキン",
        patterns: ["ラムキン"],
    },
];
const matchesPattern = (value, pattern) => {
    const normalizedValue = normalizeForMatch(value);
    const normalizedPattern = normalizeForMatch(pattern);
    return normalizedValue.includes(normalizedPattern);
};
const sortMatchers = (left, right) => {
    const leftLength = Math.max(...left.patterns.map((pattern) => pattern.length));
    const rightLength = Math.max(...right.patterns.map((pattern) => pattern.length));
    return rightLength - leftLength;
};
const orderedMatchers = [...canonicalMatchers].sort(sortMatchers);
export const normalizeBreed = (raw) => {
    const cleaned = removeAnnotations(normalizeUnicode(decodeHtmlEntities(raw)));
    const lowered = cleaned.toLowerCase();
    if (lowered.includes("mix") ||
        lowered.includes("ミックス") ||
        lowered.includes("猫ハーフ")) {
        return "ミックス";
    }
    for (const matcher of orderedMatchers) {
        if (matcher.patterns.some((pattern) => matchesPattern(cleaned, pattern))) {
            return matcher.canonical;
        }
    }
    return cleaned;
};
export const BREED_CANONICALS = canonicalMatchers.map((matcher) => matcher.canonical);
